import { Id } from "src/utils/types";
import { request } from ".";

export type Negotiation = {
  id: number;
  empresa_id: number;
  empresa: string;
  negociacao: string;
};

export type CreateNegotiationPaylod = {
  empresa: number;
  negociacao: string;
}

export const getNegotiations = async (): Promise<Negotiation[]> => {
  const response = await request.get<Negotiation[]>(`/negotiations`);

  if (!response.data) {
    return [];
  }

  return response.data;
};

export const getNegotiationById = async (id: Id): Promise<Negotiation> => {
  const response = await request.get<Negotiation>(`/negotiations/${id}`);

  return response.data;
};

export const createNegotiation = async (data: CreateNegotiationPaylod): Promise<void> => {
  await request.post('/negotiations', data);
}

export const updateNegotiation = async (id: Id, data: CreateNegotiationPaylod): Promise<void> => {
  await request.put(`/negotiations/${id}`, data);
}

export const deleteNegotiationById = async (id: Id): Promise<void> => {
  await request.delete(`/negotiations/${id}`);
};
